interface GridBuildingAnimationProps {
  size?: number;
}

export const GridBuildingAnimation = ({ size = 64 }: GridBuildingAnimationProps) => {
  return (
    <div className="inline-block" style={{ width: size, height: size }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Grid cells that animate in sequence */}
        {/* Row 1 */}
        <rect
          x="5"
          y="5"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="0s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="37.5"
          y="5"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="0.2s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="70"
          y="5"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="0.4s"
            repeatCount="indefinite"
          />
        </rect>

        {/* Row 2 */}
        <rect
          x="5"
          y="37.5"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="0.6s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="37.5"
          y="37.5"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="0.8s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="70"
          y="37.5"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="1s"
            repeatCount="indefinite"
          />
        </rect>

        {/* Row 3 */}
        <rect
          x="5"
          y="70"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="1.2s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="37.5"
          y="70"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="1.4s"
            repeatCount="indefinite"
          />
        </rect>
        <rect
          x="70"
          y="70"
          width="25"
          height="25"
          rx="4"
          fill="#76C2C5"
          opacity="0"
        >
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            dur="2s"
            begin="1.6s"
            repeatCount="indefinite"
          />
        </rect>
      </svg>
    </div>
  );
};
